import React, { useState, useRef, useEffect } from "react";
import api from "api";
import styles from "../stripe-dashboard.module.css";
import AppModal from "components/ui/AppModal/AppModal";

const AssignPlanTab = ({ users, plans, token }) => {
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedPlanId, setSelectedPlanId] = useState("");
  const [trialDays, setTrialDays]           = useState(0);
  const [loading, setLoading]               = useState(false);
  const [userSearch, setUserSearch]         = useState("");
  const [showDropdown, setShowDropdown]     = useState(false);
  const dropdownRef = useRef(null);
  const [feedbackModal, setFeedbackModal] = useState({
    open: false,
    variant: "custom",
    title: "",
    message: "",
    confirmText: "OK"
  });

  const closeFeedbackModal = () =>
    setFeedbackModal(prev => ({ ...prev, open: false }));

  useEffect(() => {
    const handler = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filteredUsers = users.filter(u =>
    u.username.toLowerCase().includes(userSearch.toLowerCase()) ||
    u.email.toLowerCase().includes(userSearch.toLowerCase())
  );

  const handleSubmit = async e => {
    e.preventDefault();
    if (!selectedUserId || !selectedPlanId) {
      setFeedbackModal({
        open: true,
        variant: "warning",
        title: "Atenção",
        message: "Selecione um cliente e um plano."
      });
      return;
    }
    setLoading(true);
    try {
      const res = await api.post(
        `/v2/stripe/users/${selectedUserId}/assign-plan`,
        {
          plan_id: selectedPlanId.toString(),
          trial_period_days: Number(trialDays) > 0 ? Number(trialDays) : null,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setFeedbackModal({
        open: true,
        variant: "success",
        title: "Sucesso!",
        message: `Plano atribuído. URL: ${res.data.payment_url}`
      });
      setSelectedUserId("");
      setSelectedPlanId("");
      setTrialDays(0);
      setUserSearch("");
    } catch (err) {
      setFeedbackModal({
        open: true,
        variant: "error",
        title: "Erro",
        message: err.response?.data?.detail || "Tente novamente."
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.card}>
        <form onSubmit={handleSubmit} noValidate>
        <div className={styles.formBody}>

          {/* Cliente */}
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Cliente</label>
            <div ref={dropdownRef} style={{ position: "relative" }}>
              <input
                type="text"
                className={styles.formControl}
                placeholder="Digite para buscar por nome ou e-mail..."
                value={userSearch}
                onChange={e => {
                  setUserSearch(e.target.value);
                  setShowDropdown(true);
                }}
                onFocus={() => setShowDropdown(true)}
                autoComplete="off"
              />
              {showDropdown && filteredUsers.length > 0 && (
                <div className={styles.dropdown}>
                  {filteredUsers.map(u => (
                    <div
                      key={u.id}
                      className={styles.dropdownItem}
                      onMouseDown={() => {
                        setSelectedUserId(u.id);
                        setUserSearch(u.username);
                        setShowDropdown(false);
                      }}
                    >
                      {u.username}
                      <span style={{ color: "#94a3b8", fontSize: "0.8rem", marginLeft: 6 }}>
                        ({u.email})
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Plano */}
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Plano</label>
            <select
              className={styles.formControl}
              value={selectedPlanId}
              onChange={e => setSelectedPlanId(e.target.value)}
              required
            >
              <option value="">Escolha um plano...</option>
              {plans.map(p => (
                <option key={p.id} value={p.id}>
                  {p.name} — R$ {p.price.toFixed(2)}/mês
                </option>
              ))}
            </select>
          </div>

          {/* Trial */}
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Período de Teste (Trial)</label>
            <div className={styles.inputGroup}>
              <input
                type="number"
                min="0"
                className={styles.formControl}
                style={{ borderRadius: "8px 0 0 8px" }}
                value={trialDays}
                onChange={e => setTrialDays(e.target.value)}
                placeholder="0"
              />
              <span className={styles.inputSuffix}>dias</span>
            </div>
            <span className={styles.formHint}>Deixe 0 para cobrança imediata.</span>
          </div>

        </div>

        <div className={styles.formActions}>
          <button
            type="submit"
            className={`${styles.button} ${styles.buttonPrimary}`}
            disabled={loading}
          >
            {loading ? (
              <>
                <div className={styles.spinner} style={{ width: 14, height: 14, borderWidth: 2 }} />
                Atribuindo...
              </>
            ) : (
              <>
                <i className="fas fa-user-tag" /> Atribuir Plano
              </>
            )}
          </button>
        </div>
        </form>
      </div>

      <AppModal
        isOpen={feedbackModal.open}
        onClose={closeFeedbackModal}
        allowOutsideClick={true}
        variant={feedbackModal.variant}
        title={feedbackModal.title}
        message={feedbackModal.message}
        confirmText={feedbackModal.confirmText}
        cancelText={null}
        onConfirm={closeFeedbackModal}
        onCancel={closeFeedbackModal}
      />
    </>
  );
};

export { AssignPlanTab };
